import styled from 'styled-components';
import { COLORS } from '@/theme';
import { Button } from '@/ui';
import PureImageUploader from 'src/shared/components/PureImageUploader/PureImageUploader';
import { ImageWithPreview } from '@/components';

export const StyledFormItemWrapper = styled.div`
  position: relative;
  min-height: 26rem;
`;

export const StyledHeaderBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
`;

export const StyledTitle = styled.span`
  display: flex;
  align-items: center;
  padding: 0;
  height: 2.875rem;
  font-size: 1.25rem;
`;

export const StyledUploadControl = styled(PureImageUploader)`
  &&& .ant-upload-disabled {
    transition: opacity 0.1s linear;
    opacity: 0.6;
    pointer-events: none;
  }
`;

export const StyledUploadButton = styled(Button)`
  &&& {
    height: 2.5rem;
    background-color: ${COLORS.YELLOW_PRIMARY};
    border-color: transparent;

    &&&:hover {
      background-color: ${COLORS.YELLOW_PRIMARY};
    }
  }
`;

export const StyledUploadIconWrapper = styled.div`
  width: 100%;
`;

export const StyledUploadDraggerTitle = styled.div`
  width: 100%;
  font-size: 1.2rem;
`;

export const StyledUploadDraggerText = styled.div`
  width: 100%;
  font-size: 0.875rem;
  color: ${COLORS.GRAY_PRIMARY};
  padding-top: 4rem;
`;

export const StyledPhotoList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 0.75rem 0;
  position: relative;
`;

export const StyledPhotoItem = styled.div`
  position: relative;
  width: 11.25rem;
  height: 11.25rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
`;

export const StyledImage = styled(ImageWithPreview)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const StyledPhotoWrapper = styled.div`
  transition: opacity 0.1s ease;
  &&&[data-is-dragging='true'] {
    opacity: 0.5;
  }

  &&&[data-is-hover='true'] {
    opacity: 0.5;
  }
`;

export const StyledActionButton = styled(Button)<{ $isDragButton?: boolean }>`
  &&& {
    position: absolute;
    top: 0.625rem;
    right: ${({ $isDragButton }) => ($isDragButton ? 'auto' : '0.625rem')};
    left: ${({ $isDragButton }) => ($isDragButton ? '0.625rem' : 'auto')};
    background: ${COLORS.WHITE};
    border: none;
    padding: 0.25rem;
    cursor: pointer;
    height: auto;

    &&&:hover {
      background: ${COLORS.WHITE};
      border: none;
    }
  }
`;
